import * as React from 'react';
import * as styles from './styles.css';

interface IPromoMenuProps {
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export const PromoMenu: React.FC<IPromoMenuProps> = ({ children, ref }) => {
  return (
    <div ref={ref} className={styles['container']}>
      {children}
    </div>
  );
};
